module.exports = __webpack_public_path__ + "img/warnings-01.d017048a.png";